import { ApiResourceFactory } from '../api.resource.factory'
import { MeasurementsRequestModel, EntityModel, MeasurementCollectionModel, MeasurementModel, MeasurementsModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

declare var msgpack: any

export interface IMeasurementsService {
    getMeasurementsForLocation(req, state?: any): ng.IPromise<MeasurementModel[]>
    getLatestMeasurementsForLocation(req, state?: any): ng.IPromise<MeasurementModel[]>
    getMeasurementsForDevice(req, state?: any): ng.IPromise<MeasurementModel[]>
    getLatestMeasurementsForDevice(req, state?: any): ng.IPromise<MeasurementModel[]>
    getMeasurementsForMeter(req, state?: any): ng.IPromise<MeasurementModel[]>
    getLatestMeasurementsForMeter(req, state?: any): ng.IPromise<MeasurementModel[]>
    getMeasurementsKPI(req, state?: any): ng.IPromise<MeasurementModel[]>
    exportMeasurements(req, state?: any): ng.IPromise<any>
}

export class MeasurementsService implements IMeasurementsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    decodeMeasurments(measurementsModel: MeasurementsModel) {
        CommonHelper.checkResultError(measurementsModel)

        var base64 = CommonHelper.Base64.decode(measurementsModel.data)
        var byteNumbers = new Array(base64.length);
        for (var i = 0; i < base64.length; i++) {
            byteNumbers[i] = base64.charCodeAt(i);
        }

        var data: any[] = msgpack.decode(byteNumbers)
        
        var result: MeasurementModel[] = []

        data.forEach((d: any[]) => {
            var dataType = d[0]
            var idLocation = d[1]
            var idMeter = d[2]
            var measures: any[] = d[3]
            var serialMbr = d[4]

            measures.forEach(measure => {
                var isDate = measure[1]
                var m = new MeasurementModel()
                m.dataType = dataType
                var date = new Date(measure[0])
                date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000)
                m.date = date
                if (idLocation) m.idLocation = idLocation;
                if (idMeter) m.idMeter = idMeter;
                m.serialNbr = serialMbr
                m.value = isDate ? new Date(measure[2]) : measure[2]

                result.push(m)
            })
        })

        return result
    }

    getMeasurementsForLocation(req: MeasurementsRequestModel, state:any = {}) {
        var get: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.measurements['getMeasurementsForLocation']
        state.request = get(req)
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getLatestMeasurementsForLocation(req: MeasurementsRequestModel, state: any = {}) {
        var get: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.measurements['getLatestMeasurementsForLocation']
        state.request = get(req)
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getMeasurementsForDevice(req: MeasurementsRequestModel, state: any = {}) {
        var get: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.measurements['getMeasurementsForDevice']
        state.request = get(req)
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getLatestMeasurementsForDevice(req: MeasurementsRequestModel, state: any = {}) {
        var get: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.measurements['getLatestMeasurementsForDevice']
        state.request = get(req)
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getMeasurementsForMeter(req: MeasurementsRequestModel, state: any = {}) {
        var get: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.measurements['getMeasurementsForMeter']
        state.request = get(req)
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getLatestMeasurementsForMeter(req: MeasurementsRequestModel, state: any = {}) {
        var get: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.measurements['getLatestMeasurementsForMeter']
        state.request = get(req)
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

     getMeasurementsKPI(req: MeasurementsRequestModel, state:any = {}) {
        var post: ng.resource.IResourceMethod<ng.resource.IResource<any>> = this.apiResource.kpi['getKpiData'];
        state.request = post(req);
        return state.request.$promise.then(this.decodeMeasurments).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state));
    }

     exportMeasurements(req, state: any = {}) {
         var get = this.apiResource.measurements['exportMeasurements']
         state.request = get(req)
         return state.request.$promise.then(result => {
             CommonHelper.checkResultError(result)             
             return (<any>result).toJSON()
         }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
     }
}
